import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function BottomNavigation({ showNavigation }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  if (!showNavigation) return null;
  
  return (
    <nav className="bottom-navigation">
      <button 
        className={`nav-btn ${location.pathname === '/calls' ? 'active' : ''}`}
        onClick={() => navigate('/calls')}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
        </svg>
        <span>Calls</span>
      </button>
      <button 
        className={`nav-btn ${location.pathname === '/messages' ? 'active' : ''}`}
        onClick={() => navigate('/messages')}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2Z"/>
        </svg>
        <span>Messages</span>
      </button>
      <button 
        className={`nav-btn ${location.pathname === '/contacts' ? 'active' : ''}`}
        onClick={() => navigate('/contacts')}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z"/>
        </svg>
        <span>Contacts</span>
      </button>
      <button 
        className={`nav-btn ${location.pathname === '/database' ? 'active' : ''}`}
        onClick={() => navigate('/database')}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
        </svg>
        <span>Evidence</span>
      </button>
    </nav>
  );
}

export default BottomNavigation;
